module.exports = __webpack_public_path__ + "media/dashboard/assets/images/channels/whatsapp-rounded-789ca0e4c7bbf5fa529f0ebb425cfbb9.svg";